import type { Product, ProductSize } from '../types/order';
import { defaultSize, isFeeProduct, isSizeSellable } from './pricing';

export type DineInQuickAdd = { pick: true } | { pick: false; size: ProductSize | null };

/**
 * Πάτημα σε προϊόν dine-in (κονσόλα ταμία ΚΑΙ app σερβιτόρου): ανοίγει επιλογή μεγέθους ή
 * μπαίνει κατευθείαν, και με ποιο μέγεθος. Ένας κανόνας για τις δύο οθόνες, ώστε το ίδιο
 * πάτημα να γράφει την ίδια γραμμή (size_id) στο ίδιο τραπέζι.
 *
 * - >1 πωλήσιμα και όχι τέλος → επιλογή, χωρίς «Κανονικό (χωρίς μέγεθος)»: η τιμή ζει στο
 *   μέγεθος (Φ5)·
 * - αλλιώς το προεπιλεγμένο πωλήσιμο (null αν δεν υπάρχει). Τέλος με κατάλοιπα μεγέθη
 *   (F1-W3-15) δεν ρωτά: χρεώνεται feeUnitGross ό,τι μέγεθος κι αν κουβαλά.
 *
 * Μετρούν μόνο τα πωλήσιμα, όπως στο withSellableSizes: ένα κρυφό δεύτερο μέγεθος δεν ανοίγει
 * επιλογή. Ανοιχτή τιμή και ζυγιζόμενα κρίνονται ΠΡΙΝ από αυτό, στον καλούντα.
 */
export function dineInQuickAdd(product: Pick<Product, 'sizes' | 'fee_category'>): DineInQuickAdd {
  const sellable = (product.sizes || []).filter(isSizeSellable);
  if (sellable.length > 1 && !isFeeProduct(product)) return { pick: true };
  return { pick: false, size: defaultSize(product.sizes) };
}
